<div class="brain-age b-dashboard-insights__container">

  <!-- Page title -->
  <div class="b-dashboard-insights__back-button">
    <a (click)="back()">
      <img src="/assets/images/dashboard/insights/back-arrow.svg" alt="">
      <span>BrainKey Relative Age Score</span>
    </a>
  </div>
  <!-- Page title -->

  <div class="content-wrap">

    <div class="info-wrap">

      <!-- General information -->
      <div class="text-wrap brain-age__text-wrap">
        <p class="text brain-age__text">
          BrainKey Relative Age Score is a measure of how young or old your brain appears. Our bodies change as we age
          and therefore also our brains. BrainKey can calculate your score (at the time your scan was done) from your
          MRI using cutting-edge technology.
        </p>
        <p class="text brain-age__text">
          The BrainKey Relative Age Score calculation should not be used to make a medical decision. If you have
          concerns
          or questions about your brain age, you should speak with your physician.
        </p>

        <div class="widgets-wrap hide_if_lower_768">
          <!-- Widgets -->
          <ng-container *ngTemplateOutlet="widgets"></ng-container>
          <!-- Widgets -->
        </div>

        <rt-loading [until]="!!personAge && !!computedBrainAge" type="linear">
          <p class="text brain-age__text">
            Your computed BrainKey Relative Age is
            @if (ageDifference < 0) {
              <span
              class="strong-text brain-age__strong-text">lower than your actual age.</span>
            }
            @if (ageDifference === 0) {
              <span
              class="strong-text brain-age__strong-text">equal to your actual age.</span>
            }
            @if (ageDifference > 0) {
              <span
              class="strong-text brain-age__strong-text">higher than your actual age.</span>
            }
          </p>
        </rt-loading>
      </div>
      <!-- General information -->


      <!-- Expansion panels -->
      <hr>
        <app-simple-expansion-panel
          class="expansion-panel brain-age__expansion-panel"
          title="What contributes to my Relative Brain Age Score?"
          >
          <p class="text brain-age__text">
            Similar to working out to keep your muscles energetic, there are things you can do to keep your brain younger.
          </p>
          <p class="text brain-age__text">
            A healthy lifestyle, balanced nutrition, and regular physical exercise can help to boost your brainpower.
            So, just like it’s a good idea to keep track of your weight and blood pressure, it’s a good idea to keep
            an eye on how your brain is aging.
          </p>
        </app-simple-expansion-panel>

        <hr>
          <app-simple-expansion-panel
            class="expansion-panel brain-age__expansion-panel"
            title="Is there anything I can do to influence this score?"
            >
            <p class="text brain-age__text">
              Similar to working out to keep your muscles energetic, there are things you can do to keep your brain younger.
            </p>
            <p class="text brain-age__text">
              A healthy lifestyle, balanced nutrition, and regular physical exercise can help to boost your brainpower.
              So, just like it’s a good idea to keep track of your weight and blood pressure, it’s a good idea to keep
              an eye on how your brain is aging.
            </p>
          </app-simple-expansion-panel>
          <!-- Expansion panels -->

        </div>

        <div class="widgets-wrap hide_if_higher_768">
          <!-- Widgets -->
          <ng-container *ngTemplateOutlet="widgets"></ng-container>
          <!-- Widgets -->
        </div>

      </div>

    </div>

    <ng-template #widgets>

      <!-- Age difference display -->
      <div class="relative-display">
        <rt-loading [until]="!!personAge && !!computedBrainAge" type="linear">
          <div class="title relative-display__title">Your BrainKey Relative Age</div>
          <div class="display-wrap relative-display__display-wrap">
            <div class="actual-age display-wrap__age-num">{{personAge}}</div>
            <div class="actual-text display-wrap__text">Actual Age</div>
            <img src="/assets/images/dashboard/insights/brain-age/ellipse.svg" alt=""
              class="ellipse display-wrap__ellipse">
            <img
              src="/assets/images/dashboard/insights/brain-age/arrow.svg"
              alt=""
              class="arrow display-wrap__arrow"
              [ngStyle]="{ transform: 'rotate(' + (ageDifference * scaleRatio) + 'deg)' }"
              >
          </div>
          <div class="relative-age relative-display__actual-age">{{computedBrainAge}}</div>
          <div class="relative-text relative-display__relative-text">Relative Brain Age</div>
        </rt-loading>
      </div>
      <!-- Age difference display -->


      <!-- Change over time -->
      <div class="changes">
        <rt-loading [until]="!!personAge && !!computedBrainAge" type="linear">
          <div class="title changes__title">Change over time</div>
          <div class="dashboard-chart-wrapper">
            @if (volumeChartConfig) {
              <div echarts class="dashboard-chart" [options]="volumeChartConfig"></div>
            }
            <div class="axis-text dashboard-chart-wrapper__axis-text">Actual Age</div>
            <div class="axis-text dashboard-chart-wrapper__axis-text dashboard-chart-wrapper__axis-text_y">
              BrainKey Relative Age
            </div>
          </div>
        </rt-loading>
      </div>
      <!-- Change over time -->

    </ng-template>
